import {ProcessStageTitle, Select} from '@hconnect/common/components'
import {useProcessStages} from '@hconnect/common/hooks/useProcessStages'
import {ControlledFormField, FormFieldBase, SelectOption} from '@hconnect/common/types'
import {Controller, FieldValues} from 'react-hook-form'

type Props<TField extends FieldValues> = FormFieldBase &
  ControlledFormField<TField> & {
    plantId: string
    onChange?: (value: string | undefined) => void
  }

export const ProcessStageSelectField = <TField extends FieldValues>(props: Props<TField>) => {
  const {data: stages} = useProcessStages(props.plantId)
  const options: SelectOption<string>[] = Array.from(stages ?? [], ([stage]) => ({
    value: stage,
    label: stage
  }))

  return (
    <Controller
      name={props.name}
      control={props.control}
      disabled={props.disabled || props.readOnly}
      render={({field, fieldState}) => (
        <Select
          data-test-id={`select-field-${field.name}`}
          name={field.name}
          options={options}
          label={props.label}
          value={field.value}
          onChange={(value) => {
            field.onChange(value)
            props.onChange?.(value)
          }}
          getOptionLabel={({value}) => <ProcessStageTitle stages={stages} stage={value} />}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          disabled={props.disabled}
          required={props.required}
          optional={props.optional}
          readOnly={props.readOnly}
        />
      )}
    />
  )
}
